import React from "react";
import { Chip, Tooltip } from "@mui/material";

import { getCancellationInfo } from "../filed/FiledCancellationNotice";

// Marks a radicado, or its copy in an expediente, as annulled. The motive rides
// in the tooltip so a long one doesn't break the table.
export default function AnnulledChip({ source, sx }) {
  const info = getCancellationInfo(source);
  const title = [
    source?.filedId ? `Radicado ${source.filedId} anulado` : "Radicado anulado",
    info?.reason ? `Motivo: ${info.reason}` : null,
    info?.at ? `Fecha: ${info.at.format("LL")}` : null,
  ].filter(Boolean).join(" · ");
  return (
    <Tooltip title={title}>
      <Chip label="ANULADO" color="error" size="small" sx={{ fontWeight: 700, ...sx }} />
    </Tooltip>
  );
}
